/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Auth from "../../shared/Auth";

export const ChatBubbleGlobal = {
    setOrder(orderID) { }
};

class ChatBubble extends BaseCom {
    constructor(props) {
        super(props);
        this.setOrder = this.setOrder.bind(this);
        ChatBubbleGlobal.setOrder = this.setOrder;
    }

    componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
    }

    setOrder(orderID) {
        this.setState({ orderID: orderID });
    }

    render() {
        return this.props.location.pathname.indexOf('/chat') < 0 && <div className="ChatBubble">
            {this.state.orderID && <Link to={'/chat/new' + (this.state.orderID ? '/' + this.state.orderID : '')} className="btn btn-success btn-lg"><Icon icon="faComment" /></Link>}
            {!this.state.orderID && this.state.user?.roles?.indexOf('admin') !== -1 && <Link to="/chat/channel/new" className="btn btn-primary btn-lg"><Icon icon="faComment" /></Link>}
        </div>;
    }
}

export default withParamsAndNavigate(ChatBubble);